import { createStore, applyMiddleware} from "redux";
import createSagaMiddleware from 'redux-saga';
import rootReducer from "./redux/reducers";
import { watcherSaga } from "./redux/sagas";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

const { logger } = require('redux-logger'); // eslint-disable-line

const persistConfig = {
  key: 'root',
  storage,
}
 
const persistedReducer = persistReducer(persistConfig, rootReducer)
const sagaMiddleware = createSagaMiddleware();  
const middleWare = [sagaMiddleware,logger];
const store = createStore(persistedReducer, {}, composeWithDevTools(applyMiddleware(...middleWare)));
export let persistor = persistStore(store)
sagaMiddleware.run(watcherSaga);

export default store;

